export default __webpack_public_path__ + "static/media/element_103.c7a9cbeb.jpg";